import { OrganizationDataController } from './organization-data.controller';

export const OrganizationDataComponent: ng.IComponentOptions = {
    template: require('./organization-data.html'),
    controller: OrganizationDataController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/registration/organization-data/organization-data.component.ts